import { render, staticRenderFns } from "./EchartsBar.vue?vue&type=template&id=0b61d203"
import script from "./EchartsBar.vue?vue&type=script&lang=js"
export * from "./EchartsBar.vue?vue&type=script&lang=js"
import style0 from "./EchartsBar.vue?vue&type=style&index=0&id=0b61d203&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports